import { Inject, Injectable } from "@angular/core";
import { GetConfigUseCase } from "../../core/config/get-config.use-case";
import { IRelativeCurrencyValues } from "../../core/config/interfaces";
import { CURRENCY_TOKEN } from "@karma-games/angular-devkit/src/lib/modules/pipes";

@Injectable({
    providedIn: 'root'
})
export class CurrencyService {
    private relativeValues: IRelativeCurrencyValues[] = [];

    constructor(private getConfigUseCase: GetConfigUseCase,
                @Inject(CURRENCY_TOKEN) private currency: string) {
        this.getConfigUseCase.execute()
            .then((config) => {
                this.relativeValues = config ? config.currencyRelativeValues : [];
            });
    }

    convertCurrencyAmount(amount: number, userCurrency: string | undefined | null): number {
        if (userCurrency === this.currency || !userCurrency) {
            return amount;
        } else {
            const relativeValue: IRelativeCurrencyValues = this.relativeValues.find(v => v.currency === userCurrency) ??
                { currency: userCurrency, value: 1 };
            const myUserCurrencyRelativeValue: IRelativeCurrencyValues = this.relativeValues.find(v => v.currency === this.currency) ??
                { currency: this.currency, value: 1 };
            return (amount / relativeValue.value) * myUserCurrencyRelativeValue.value;
        }
    }
}
